import MessageBanner from 'LuxKit/Banners/MessageBanner'
import { useCallback, useContext, useEffect } from 'react'
import * as React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useInView } from 'react-intersection-observer'
import { calculateNights } from '../../../../../tripPlanner/utils'
import SearchTileEventsContext, { SearchTileEvents } from '../../../OfferList/OfferListTiles/SearchOfferTiles/SearchTileEventsContext'

interface Props {
  checkIn: string
  checkOut: string
}

function HotelSearchTileAlternativeDatesBanner({ checkIn, checkOut }: Props) {
  const intl = useIntl()
  const searchTileEventsDispatch = useContext(SearchTileEventsContext)
  const nights = calculateNights(checkIn, checkOut)

  const [inViewRef, hasBeenInView] = useInView({
    threshold: 0.8,
    triggerOnce: true,
  })

  useEffect(() => {
    if (hasBeenInView) {
      searchTileEventsDispatch({
        type: SearchTileEvents.viewAlternativeDatesBanner,
      })
    }
  // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [hasBeenInView])

  const handlePrimaryActionClick = useCallback(() => {
    searchTileEventsDispatch({
      type: SearchTileEvents.clickAlternativeDateViewOffer,
    })
  }, [searchTileEventsDispatch])

  const viewOfferLabel = intl.formatMessage({
    id: 'cIf41JYsSRIhXzVF86mj',
    defaultMessage: 'View offer',
    description: 'CTA button on alternative dates banner to view the offer',
  })

  return <MessageBanner
    ref={inViewRef}
    kind="informational-primary"
    secondaryActionButtonProps={{
      children: viewOfferLabel,
      onClick: handlePrimaryActionClick,
    }}
  >
    <FormattedMessage
      id="tWcUL2Ea4YOQOZ0zFELa"
      defaultMessage="Stay for at least <strong>{nightCountLabel}</strong> to unlock a limited time deal on this hotel."
      description="Alternative dates banner explaining minimum stay requirement for a deal"
      values={{
        nightCountLabel: intl.formatMessage(
          {
            id: 'rwxnYal6I2uS3z-AY2Ti',
            defaultMessage: '{nights, plural, one {# night} other {# nights}}',
            description: 'Minimum night count label shown in alternative dates deal banner',
          },
          { nights },
        ),
        strong: (chunks: React.ReactNode) => <strong>{chunks}</strong>,
      }}
    />
  </MessageBanner>
}

export default HotelSearchTileAlternativeDatesBanner
